/**
 * Application-wide constants for Meduler
 * 
 * This file contains constants that define application-wide behaviors,
 * states, and configurations that are used across multiple components.
 */

/**
 * User Experience States
 * 
 * FIRST_RUN: User has not added any medications yet (show onboarding, intros)
 * SECOND_RUN: User has added at least one medication (focused on medication management)
 */
export const USER_EXPERIENCE_STATES = {
  FIRST_RUN: 'first_run',
  SECOND_RUN: 'second_run'
} as const;

export type UserExperienceState = (typeof USER_EXPERIENCE_STATES)[keyof typeof USER_EXPERIENCE_STATES];
